export default (resource, item) => item.resourceId === resource.id && item.resourceType === resource.type;
